import { createSlice } from '@reduxjs/toolkit'
import { bidsInitialMainFilter } from '../../pages/Procurement/BIDs/initialValues'

const bidsSlice = createSlice({
  name: 'bidsSlice',
  initialState: {
    bidsDetailsData: [],
    rfqMainIdSlice: 0,
    bidsRowsDetailsSlice: [],
    bidsMainFilterSlice: bidsInitialMainFilter,
    vendorCodeReference: null,
  },
  reducers: {
    updateBidsDetailsData: (state, action) => {
      state.bidsDetailsData = action.payload
    },

    updateRFQMainIdSlice: (state, action) => {
      state.rfqMainIdSlice = action.payload
    },

    updatebidsRowsDetailsSlice: (state, action) => {
      state.bidsRowsDetailsSlice = action.payload
    },

    updateBidsMainFilterSlice: (state, action) => {
      state.bidsMainFilterSlice = action.payload
    },

    updateVendorCodeReference: (state, action) => {
      state.vendorCodeReference = action.payload
    },
  },
})

export const {
  updateBidsDetailsData,
  updateRFQMainIdSlice,
  updatebidsRowsDetailsSlice,
  updateBidsMainFilterSlice,
  updateVendorCodeReference,
} = bidsSlice.actions

export const bidsDataReducer = bidsSlice.reducer
